import { Article, Cancel, CheckCircle, Comment, Mail, Payment, ThumbUp, UploadFile } from '@mui/icons-material';
import * as theme from '../../../theme';
import { Chip } from '@mui/material';
import dayjs from 'dayjs';

function getStatus(status, isPractitioner) {
  if (status === 1) {
    return isPractitioner ? "Downpayment Paid" : "Ready to Mail Kit";
  } else if (status === 2) {
    return isPractitioner ? "Kit Mailed" : "Awaiting Client Form";
  } else if (status === 3) {
    return isPractitioner ? "Client Form Submitted" : "Ready for Scan";
  } else if (status === 4) {
    return isPractitioner ? "Scan Initiated" : "Ready to Upload Reports & Mail Remedy";
  } else if (status === 5) {
    return isPractitioner ? "Reports Uploaded" : "Ready to Mail Imprint Remedy";
  } else if (status === 6) {
    return isPractitioner ? "Imprint Remedy Mailed" : "Ready to Upload Reports";
  } else if (status === 7) {
    return "Scan Completed";
  }
}

function getIcon(status, isPractitioner) {
  if (status === 1) {
    return isPractitioner ? <Payment /> : <Mail />;
  } else if (status === 2) {
    return isPractitioner ? <Mail /> : <Cancel />;
  } else if (status === 3) {
    return isPractitioner ? <Article /> : <ThumbUp />;
  } else if (status === 4) {
    return isPractitioner ? <ThumbUp /> : <Mail />;
  } else if (status === 5) {
    return isPractitioner ? <UploadFile /> : <Mail />;
  } else if (status === 6) {
    return isPractitioner ? <Mail /> : <UploadFile />;
  } else if (status === 7) {
    return <CheckCircle />;
  }
}

export default function ActiveScanItem({ children, ...props }) {
  return (
    <div style={{ display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
      <div className={'cardLink'} style={{ display: 'flex', flex: 3, width: '100%', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }} onClick={() => props.actionLink != null ? props.actionLink() : null}>
        <div style={{ ...theme.Container.flexRowFixed, padding: 8, alignItems: 'center' }}>
          <Chip label={dayjs(props.scan.date).format('MMM DD')} color={'secondary'} />
          <div style={{ flex: 1, fontSize: 14, fontWeight: 500 }}>
            {props.clientName}
            <br />
            <span style={{ fontWeight: 'normal', fontSize: '0.85em', color: theme.Colors.GrayMedium }}>
              {props.practitionerName}
            </span>
          </div>
          <div style={{ flex: 1, fontSize: 14, fontWeight: 500, justifyContent: 'center', alignItems: 'center' }}>
            <span style={{ display: 'inline-flex', alignItems: 'center' }}>
              {props.scan.commentsToRead &&
                <><span style={{ marginRight: 7 }}><Comment /></span><span>Unread Comments</span></>
              }
              {!props.scan.commentsToRead &&
                <><span style={{ marginRight: 7 }}>{getIcon(props.scan.scanStatus, props.isPractitioner)}</span><span>{getStatus(props.scan.scanStatus, props.isPractitioner)}</span></>
              }
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}